<template>
  <div class="news-wrap centerWidth">
    <div class="tag_position d-flex d-align-center">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <span>公开课程</span>
    </div>
    <div>
      <div class="new-w9 centerWidth">
        <div class="new-tit-3 d-flex d-align-center">
          <div class="line"></div>
          <div class="tit cur">公开课程</div>
        </div>
        <div class="list_div">
          <div class="news_a d-flex" v-for="(item,index) in pageList" :key="index" @click="toDetails(item)">
            <div class="img" v-if="item.image">
              <img class="cover" :src="item.image">
            </div>
            <div class="right">
              <h2 class="text_ov eli1">{{ item.title }}</h2>
              <p class="desc eli2">{{ item.abstract }}</p>
              <div class="date" v-if="item.create_time">{{item.create_time.split(' ')[0]}}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="pageList.length>0">
<!--        <div class="dynamic-content">-->
<!--          <div v-for="(item, index) in pageList" :key="index">-->
<!--            <div class="dynamic-item" @click="toDetails(item)">-->
<!--              <div style="display: flex;width: 100%;">-->
<!--                <div class="date" v-if="item.create_time">-->
<!--                  <div class="day">{{ item.create_time.slice(8, 10) }}</div>-->
<!--                  <div class="month">{{ item.create_time.slice(0, 7) }}</div>-->
<!--                </div>-->
<!--                <div class="content-wrap">-->
<!--                  <div class="title">{{-->
<!--                      item.title-->
<!--                    }}-->
<!--                  </div>-->
<!--                  <div class="content">{{ item.abstract }}</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="left-arrow"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div style="text-align: center;padding: 30px 0 50px 0">
          <el-pagination
              :page-size="10"
              :current-page="pageNum"
              :background="true"
              layout="prev, pager, next"
              @current-change="currentChange"
              :total="total">
          </el-pagination>
        </div>
      </div>
      <noData v-if="pageList.length==0">
        没有相关内容~
      </noData>
    </div>
  </div>
</template>

<script>
import {
  articlelists
} from "@/api/index";

export default {
  name: "policyNews",
  data() {
    return {
      pageNum: 1, // 当前页数
      total: 0, // 列表总条数
      pageList: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      let ajaxData = {
        page_size: 10,
        page_no: this.pageNum,
        cid: 3
      }
      articlelists(ajaxData).then(res => {
        if (res.code == 1) {
          let list = res.data.lists
          this.pageList = list
          this.total = res.data.count
        }
      })
    },
    currentChange(val) {
      this.pageNum = val
      this.getList()
    },
    toDetails(item) {
      if (item.url) {
        window.open(item.url)
      }else{
        this.$router.push({
          path: 'detail',
          query: {
            id: item.id,
            type:3
          }
        })
      }
    },
  }
}
</script>

<style scoped lang="scss">
.new-w9 {
  margin-top: 30px;

  .new-tit-3 {
    background: #f6f5f5;
    font-size: 20px;
    font-weight: bold;

    .line {
      margin-right: 15px;
      width: 5px;
      height: 48px;
      background: #2257ab;
      border-radius: 2px;
    }
  }

  .list_div {
    margin-top: 30px;
    border-top: 1px solid #EEEEEE;

    .news_a {
      padding: 30px 30px;
      width: calc(100% - 60px);
      border-bottom: 1px solid #EEEEEE;
      cursor: pointer;

      &:hover {
        background-color: #F2F9FF;
      }

      .cover {
        width: 150px;
        margin-right: 30px;
        object-fit: cover;
        border-radius: 6px;
      }

      .right {

        .text_ov {
          font-size: 20px;
          color: #333333;
        }

        .desc {
          margin: 10px 0;
          color: #666666;
        }

        .date {
          color: #999;
          font-size: 13px;
        }
      }
    }
  }
}

.dynamic-content {
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;

  .dynamic-item {
    padding: 0 28px;
    margin-bottom: 24px;
    width: 585px;
    height: 160px;
    cursor: pointer;
    background: #FFFFFF;
    box-shadow: 0px 10px 40px 0px rgba(5, 18, 35, 0.06);
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 8px;
  }

  & > div:nth-child(2n+1) {
    margin-right: 30px;
  }

  .day {
    width: 70px;
    height: 52px;
    line-height: 52px;
    background: #2257ab;
    border-radius: 0px 20px 0px 0px;
    font-size: 32px;
    font-family: Arial;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 6px;
  }

  .month {
    width: 70px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #CFAA5C;
    font-size: 16px;
    font-family: Arial;
    font-weight: bold;
    color: #FFFFFF;
  }

  .content-wrap {
    width: 80%;
    position: relative;
    margin-left: 24px;
    align-self: center;

    .title {
      margin-bottom: 23px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    .content {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #5A5F66;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .dynamic-item .left-arrow {
    background-image: url("../assets/images/jiantou.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    align-self: flex-end;
    margin-top: 16px;
  }

  .dynamic-item:hover .title {
    color: #2257ab;
  }

  .dynamic-item:hover .left-arrow {
    height: 12px;
    width: 40px;
  }
}
</style>
